import { render, staticRenderFns } from "./viewBillDetail-yf.vue?vue&type=template&id=2bbd510d"
import script from "./viewBillDetail-yf.vue?vue&type=script&lang=js"
export * from "./viewBillDetail-yf.vue?vue&type=script&lang=js"
import style0 from "./viewBillDetail-yf.vue?vue&type=style&index=0&id=2bbd510d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports